import { makeStyles, mergeClasses } from '@fluentui/react-components';

import { palette } from '../../theme';

export type DotSpinnerProps = {
    label?: string;
    className?: string;
};

export const DotSpinner: React.FC<DotSpinnerProps> = ({ label = 'Loading', className }) => {
    const classes = useStyles();

    return (
        <div className={mergeClasses(classes.root, className)} role="status" aria-label={label}>
            <span className={mergeClasses(classes.dot, classes.dotA)} style={{ animationDelay: '0s' }} />
            <span className={mergeClasses(classes.dot, classes.dotB)} style={{ animationDelay: '0.15s' }} />
            <span className={mergeClasses(classes.dot, classes.dotC)} style={{ animationDelay: '0.3s' }} />
        </div>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
    },
    dot: {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        animationName: {
            '0%, 80%, 100%': { transform: 'scale(0.5)', opacity: 0.4 },
            '40%': { transform: 'scale(1)', opacity: 1 },
        },
        animationDuration: '1.2s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
    },
    dotA: {
        backgroundColor: palette.accentBgStrong,
    },
    dotB: {
        backgroundColor: palette.accent,
    },
    dotC: {
        backgroundColor: palette.accentHover,
    },
});
